import { Directive, TemplateRef, inject } from '@angular/core';

/**
 * Marks a template as an extra header action, rendered between the title block
 * and the close X (e.g. a wizard's "Save & exit" text button):
 *
 *   <app-modal ...>
 *     <ng-template modalHeaderAction>
 *       <button (click)="saveExit()">Save & exit</button>
 *     </ng-template>
 *   </app-modal>
 */
@Directive({
  selector: 'ng-template[modalHeaderAction]',
})
export class ModalHeaderActionDirective {
  readonly template = inject<TemplateRef<unknown>>(TemplateRef);
}
